import { RootState } from "../store";
import { INotice, NoticePlacement } from "./types";

export const noticesSelector = (state: RootState) => state.notices;

// Подходит ли объявление абонементу: пустой membership_ids — ко всем,
// иначе membershipId из 1С должен быть в списке.
// Если membershipId неизвестен — только объявления «для всех».
export const isNoticeForMembership = (
  notice: INotice,
  membershipId?: string | number | null
): boolean => {
  if (!notice.membership_ids || notice.membership_ids.length === 0) {
    return true;
  }
  if (membershipId === undefined || membershipId === null || membershipId === "") {
    return false;
  }
  return notice.membership_ids.includes(String(membershipId));
};

export const filterNotices = (
  notices: INotice[],
  placement: NoticePlacement,
  membershipId?: string | number | null
): INotice[] =>
  (notices || [])
    .filter(
      (notice) =>
        notice.placement === placement && isNoticeForMembership(notice, membershipId)
    )
    .sort((a, b) => a.sort_order - b.sort_order);

// Использование: useSelector(selectNoticesFor("CLUB_CARD"), shallowEqual)
export const selectNoticesFor =
  (placement: NoticePlacement, membershipId?: string | number | null) =>
  (state: RootState): INotice[] =>
    filterNotices(state.notices.notices, placement, membershipId);
